export type LayoutEntity<Entity, LayoutKey extends string> = { [Key in LayoutKey]?: Entity };

export const enum HorizontalAlignment
{
    Left,
    Center,
    Right,
}

export const enum VerticalAlignment
{
    Top,
    Center,
    Bottom,
}
